import React from "react";
// componentes
import TotalizersChart from "./totalizerChart";

export default function Totalizers(props) {
  const { users, usersTable } = props;

  return (
    <>
      <TotalizersChart title="Single" users={users} usersTable={usersTable} />
      <TotalizersChart title="Duplo" users={users} usersTable={usersTable} />
      <TotalizersChart title="Triplo" users={users} usersTable={usersTable} />
      <TotalizersChart
        title="Quadruplo"
        users={users}
        usersTable={usersTable}
      />
    </>
  );
}
